import React, { Component, Fragment } from 'react'
import PropTypes from "prop-types"

class Reason extends Component {
  static propTypes = {
    data: PropTypes.object,
    claim_id: PropTypes.string
  }
  
  static defaultProps = {
    data: {},
    claim_id: ''
  }

  constructor(props) {
    super(props);
    this.state = {
      reason: ''
    };
  }

  onChange = (e) => {
    let inputValue = e.currentTarget.value
    this.props.onChange(inputValue)
    this.setState({ reason: inputValue })
  }

  render() {
    const { onChange } = this
    return (
      <Fragment>
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header bg-light font-size-title font-weight-bold">Reason</div>
              <div className="multi-collapse show" id="multiCollapseExample2">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <textarea className="form-control" rows="5" placeholder="Reason" name="reason" onChange={onChange} value={this.state.reason} ></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

export default Reason